import classNames from "../../../utils/classNames";

export const ButtonInput = ({
  label,
  isSubmit,
  onClick,
  classes,
  disabled = false,
}) => {
  return (
    <button
      className={classNames(
        "rounded-md border border-transparent bg-orange-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-orange-700",
        "disabled:bg-gray-200 disabled:border disabled:border-gray-600/10",
        classes,
      )}
      onClick={onClick}
      disabled={disabled}
      type={`${isSubmit ? "submit" : "button"}`}
    >
      {label}
    </button>
  );
};
